import httpClient from "../httpClient";

const END_POINT = '/typeSite'

const getAllSiteTypes = () => httpClient.get(END_POINT)
const getSiteTypeById = (id) => httpClient.get(`${END_POINT}/${id}`)
const createSiteType = (siteType) => httpClient.post(END_POINT, siteType)
const updateSiteType = (id, siteType) => httpClient.put(`${END_POINT}/${id}`, siteType)

export {
  getAllSiteTypes,
  getSiteTypeById,
  createSiteType,
  updateSiteType
}